var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacherType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 24,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.6666 18.6667V29.3333C22.6666 30.8061 23.8605 32 25.3333 32H38.6666C40.1394 32 41.3333 30.8061 41.3333 29.3333V18.6667C41.3333 17.1939 40.1394 16 38.6666 16H25.3333C23.8605 16 22.6666 17.1939 22.6666 18.6667Z",
    fill: "#1C0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3333 30.0001C19.3333 28.1591 20.8257 26.6667 22.6666 26.6667C24.5076 26.6667 26 28.1591 26 30.0001C26 31.841 24.5076 33.3334 22.6666 33.3334C20.8257 33.3334 19.3333 31.841 19.3333 30.0001Z",
    fill: "#1C0054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0832 31.0909C31.5852 31.321 31.8057 31.9146 31.5756 32.4167C30.7689 34.1767 27.9096 37.3636 22.6665 37.3636C18.2126 37.3636 16.0249 39.6053 15.5427 40.4819C15.2766 40.9658 14.6685 41.1424 14.1846 40.8762C13.7007 40.6101 13.5241 40.002 13.7903 39.5181C14.6415 37.9705 17.5204 35.3636 22.6665 35.3636C27.0234 35.3636 29.2308 32.7323 29.7574 31.5833C29.9876 31.0813 30.5811 30.8608 31.0832 31.0909Z",
    fill: "#1C0054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 21.3333C27 20.781 27.4477 20.3333 28 20.3333L36 20.3333C36.5523 20.3333 37 20.781 37 21.3333C37 21.8855 36.5523 22.3333 36 22.3333L28 22.3333C27.4477 22.3333 27 21.8855 27 21.3333Z",
    fill: "#1C0054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 26.6667C31 26.1145 31.4477 25.6667 32 25.6667H36C36.5523 25.6667 37 26.1145 37 26.6667C37 27.219 36.5523 27.6667 36 27.6667H32C31.4477 27.6667 31 27.219 31 26.6667Z",
    fill: "#1C0054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherType);
export default __webpack_public_path__ + "static/media/teacher-type.86daf8aba98c206f316f100adcc2401a.svg";
export { ForwardRef as ReactComponent };